__turbopack_context__.v({
  "brand": "shell-module__vw6eYW__brand",
  "brandMeta": "shell-module__vw6eYW__brandMeta",
  "brandName": "shell-module__vw6eYW__brandName",
  "content": "shell-module__vw6eYW__content",
  "footer": "shell-module__vw6eYW__footer",
  "frame": "shell-module__vw6eYW__frame",
  "shell": "shell-module__vw6eYW__shell",
  "sider": "shell-module__vw6eYW__sider",
  "siderInner": "shell-module__vw6eYW__siderInner",
  "signedIn": "shell-module__vw6eYW__signedIn",
});
